import { IStoreState } from "./store";

export const getUserPassengers = (state: IStoreState) =>
  state.rootReducer.userPassengers;

export const getUserSelectedTravelerId = (state: IStoreState) =>
  state.rootReducer.userSelectedTravelerId;
